import BaseForBases from '../components/BaseForBases';

class BasePage extends BaseForBases {

    loadOnConstructor(){
    }
}

export default BasePage;
